import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { usePageMeta } from "@/components/site/usePageMeta";
import { KestrelWidget } from "@/components/site/KestrelWidget";
import { FeaturedCities } from "@/components/site/FeaturedCities";
import { ContactSection } from "@/components/site/ContactSection";

// /idx — the main IDX home search. iHomeFinder Kestrel renders the complete
// search experience here: search form, listing results, and property detail
// pages (all under the /idx/* path). Keep this page lean so the MLS content
// stays front and center; MLS compliance elements are rendered by iHomeFinder.
export default function IdxPage() {
  usePageMeta(
    "Search Homes | Wallstreet Realty",
    "Search live Southern California MLS listings: homes for sale across Los Angeles County, Orange County, and nearby communities with Wallstreet Realty."
  );
  return (
    <>
      <section className="pt-[70px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 lg:pt-10 pb-2">
          <nav className="flex items-center gap-1.5 text-xs text-[#2D2D37]/50 mb-4" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-[#254369]">Home</Link>
            <ChevronRight size={13} />
            <span className="text-[#254369] font-medium">Search Homes</span>
          </nav>
          <h1 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl leading-tight text-[#2D2D37]">
            Search Southern California Homes
          </h1>
          <p className="mt-3 text-base sm:text-lg text-[#2D2D37]/70 max-w-2xl">
            Live MLS listings updated through iHomeFinder IDX. Save searches,
            favorite homes, and reach out when you're ready to tour.
          </p>
        </div>
      </section>

      <section className="py-8 lg:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <KestrelWidget minHeight={720} testid="idx-full-search" />
          <p className="text-center text-sm text-[#2D2D37]/60 mt-6">Need help finding a home? <Link to="/contact" className="text-[#254369] font-medium hover:text-[#C9A961]">Contact us.</Link></p>
        </div>
      </section>

      <FeaturedCities />
      <ContactSection />
    </>
  );
}
